(function () {
  function openFooterContactTab() {
    var tabsRoot = document.querySelector('[data-lgk-footer-tabs]');
    if (!tabsRoot) return false;

    var tabs = tabsRoot.querySelectorAll('[data-lgk-footer-tab]');
    var panels = tabsRoot.querySelectorAll('[data-lgk-footer-panel]');
    var contactPanel = document.getElementById('lgk-footer-panel-contact');
    if (!contactPanel) return false;

    var contactIndex = -1;
    panels.forEach(function (panel, index) {
      if (panel === contactPanel) contactIndex = index;
    });
    if (contactIndex < 0) return false;

    tabs.forEach(function (tab, index) {
      var selected = index === contactIndex;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;
    });
    panels.forEach(function (panel, index) {
      panel.hidden = index !== contactIndex;
    });
    return true;
  }

  function scrollToContactForm(form) {
    var target = form.closest('#lgk-footer-contact') || form.closest('.lgk-footer-contact') || form;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function bindContactValidation() {
    document.querySelectorAll('.lgk-contact-form__form').forEach(function (form) {
      if (form.dataset.lgkValidationBound) return;
      form.dataset.lgkValidationBound = '1';

      var banner = form.querySelector('.lgk-contact-form__validation-banner');
      if (!banner) {
        banner = document.createElement('div');
        banner.className = 'lgk-contact-form__validation-banner';
        banner.setAttribute('role', 'alert');
        banner.hidden = true;
        form.insertBefore(banner, form.firstChild);
      }

      function clearValidation() {
        form.querySelectorAll('.is-invalid').forEach(function (el) {
          el.classList.remove('is-invalid');
        });
        banner.hidden = true;
      }

      function showMessage(text) {
        banner.textContent = text;
        banner.hidden = false;
      }

      function markInvalid(field) {
        var subject = field.closest('[data-lgk-contact-subject]');
        if (subject) {
          subject.classList.add('is-invalid');
          return subject;
        }
        if (field.type === 'checkbox') {
          var consent = field.closest('.lgk-contact-form__consent');
          if (consent) {
            consent.classList.add('is-invalid');
            return consent;
          }
        }
        var container = field.closest('.form-control, .lgk-contact-form__field');
        if (container) container.classList.add('is-invalid');
        return container || field;
      }

      function isFooterForm() {
        return !!form.closest('.lgk-contact-form--footer');
      }

      function revealFooterForm() {
        if (!isFooterForm()) return;
        openFooterContactTab();
      }

      form.addEventListener(
        'invalid',
        function (e) {
          e.preventDefault();
          revealFooterForm();
          var field = e.target;
          if (field.name === 'contact[Sujet]' && !field.value) {
            showMessage('Choisissez un sujet dans la liste avant d\'envoyer.');
          } else {
            showMessage('Veuillez compléter tous les champs obligatoires marqués *.');
          }
          var focusTarget = markInvalid(field);
          scrollToContactForm(form);
          if (focusTarget && focusTarget.focus) focusTarget.focus({ preventScroll: true });
        },
        true
      );

      form.addEventListener('submit', function (e) {
        clearValidation();

        var subjectField = form.querySelector('select[name="contact[Sujet]"]');
        if (subjectField && subjectField.required && !subjectField.value.trim()) {
          e.preventDefault();
          markInvalid(subjectField);
          revealFooterForm();
          showMessage('Choisissez un sujet dans la liste avant d\'envoyer.');
          scrollToContactForm(form);
          subjectField.focus({ preventScroll: true });
          return;
        }

        if (!form.checkValidity()) {
          e.preventDefault();
          revealFooterForm();
          showMessage('Veuillez compléter tous les champs obligatoires marqués *.');
          var first = form.querySelector(':invalid');
          if (first) {
            markInvalid(first);
            scrollToContactForm(form);
            first.focus({ preventScroll: true });
          }
          return;
        }

        if (isFooterForm()) {
          try {
            sessionStorage.setItem('lgkFooterContactPosted', '1');
          } catch (err) {}
        }
      });
    });
  }

  function focusPostedContactForm() {
    var posted = document.querySelector('.lgk-contact-form[data-lgk-contact-posted="success"]');
    if (!posted) return;

    var form = posted.querySelector('form');
    if (form && form.closest('.lgk-contact-form--footer')) {
      openFooterContactTab();
    }
    posted.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function boot() {
    bindContactValidation();
    focusPostedContactForm();

    if (window.location.hash === '#lgk-footer-contact') {
      openFooterContactTab();
      var anchor = document.getElementById('lgk-footer-contact');
      if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
